export function YoutubeIcon({className = "" }) {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.994 11.3906L19.369 15.0134L12.994 18.6362V11.3906ZM30.4851 3.21429V26.7857C30.4851 28.5603 29.0454 30 27.2708 30H3.69939C1.92484 30 0.485107 28.5603 0.485107 26.7857V3.21429C0.485107 1.43973 1.92484 0 3.69939 0H27.2708C29.0454 0 30.4851 1.43973 30.4851 3.21429ZM27.6726 15.0201C27.6726 15.0201 27.6726 11.029 27.1637 9.11384C26.8824 8.0558 26.0588 7.22545 25.0074 6.9442C23.1123 6.42857 15.4851 6.42857 15.4851 6.42857C15.4851 6.42857 7.85788 6.42857 5.96279 6.9442C4.91145 7.22545 4.08779 8.0558 3.80654 9.11384C3.29761 11.0223 3.29761 15.0201 3.29761 15.0201C3.29761 15.0201 3.29761 19.0112 3.80654 20.9263C4.08779 21.9844 4.91145 22.7812 5.96279 23.0625C7.85788 23.5714 15.4851 23.5714 15.4851 23.5714C15.4851 23.5714 23.1123 23.5714 25.0074 23.0558C26.0588 22.7746 26.8824 21.9777 27.1637 20.9196C27.6726 19.0112 27.6726 15.0201 27.6726 15.0201Z"
        fill="currentColor"
      />
    </svg>
  );
}
